module.exports = __webpack_public_path__ + "static/media/add_file.abd429dc.svg";